var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_9133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7843 11.7534C21.7843 11.0057 21.7236 10.2539 21.5943 9.51825H11.2188V13.7541H17.1603C16.9138 15.1203 16.1216 16.3288 14.9615 17.0968V19.8453H18.5063C20.5879 17.9294 21.7843 15.1001 21.7843 11.7534Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2205 22.5007C14.1872 22.5007 16.6892 21.5266 18.5121 19.8452L14.9673 17.0967C13.9811 17.7677 12.7079 18.1476 11.2245 18.1476C8.3548 18.1476 5.92158 16.2116 5.04853 13.6086H1.39062V16.4419C3.25798 20.1564 7.0614 22.5007 11.2205 22.5007Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04274 13.6086C4.58197 12.2424 4.58197 10.7631 5.04274 9.39696V6.5636H1.38888C-0.171292 9.67181 -0.171292 13.3338 1.38888 16.442L5.04274 13.6086Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2205 4.85386C12.7888 4.8296 14.3045 5.41972 15.4402 6.50295L18.5808 3.3624C16.5922 1.49505 13.9528 0.468406 11.2205 0.500741C7.0614 0.500741 3.25798 2.84504 1.39062 6.56357L5.04449 9.39694C5.9135 6.78992 8.35076 4.85386 11.2205 4.85386Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_9133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.7b8de5a0fd06a9546ff51aca017c5bca.svg";
export { ForwardRef as ReactComponent };